module.exports = __webpack_public_path__ + "img/ct-icon-map.50e85137.svg";